import { useState, useCallback } from 'react';
import { t20aApi, CFT160 } from '../../../services/t20aApi';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master */
  const resolveAllNames = useCallback(async (data: Partial<CFT160>) => {
    const entries: [string, string, string][] = [
      ['chairman', 'employee', data.ft160_17 || ''],
      ['recorder', 'employee', data.ft160_21 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        t20aApi.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await t20aApi.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
